export const theme = {
  colors: {
    bg: "#6f7c40",
    bgDeep: "#4c5726",
    bgCard: "#40491f",
    bgSurface: "#40491f",
    accent: "#f5c685",
    accentLight: "#E8A030",
    accentGlow: "rgba(212, 128, 10, 0.18)",
    accentMuted: "rgba(212, 128, 10, 0.08)",
    earth: "#caac87",
    earthLight: "#8C6840",
    cream: "#F0E6D3",
    creamMuted: "#BFB09A",
    textPrimary: "#fffbf3",
    textSecondary: "#e9d9c9",
    textMuted: "#dfcebd",
    border: "rgba(212, 128, 10, 0.12)",
    borderSubtle: "rgba(240, 230, 211, 0.06)",
  },
  fonts: {
    display: "'Montserrat', Georgia, serif",
    body: "'Montserrat', sans-serif",
    mono: "'Montserrat', monospace",
  },
  spacing: {
    xs: "0.5rem",
    sm: "1rem",
    md: "2rem",
    lg: "4rem",
    xl: "8rem",
  },
  radius: {
    sm: "4px",
    md: "12px",
    lg: "24px",
    pill: "999px",
  },
  transitions: {
    fast: "0.2s ease",
    base: "0.4s ease",
    slow: "0.7s cubic-bezier(0.16, 1, 0.3, 1)",
  },
};

export const globalFontImport = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500&family=DM+Sans:wght@300;400;500&family=DM+Mono:wght@400;500&display=swap');
`;
